// extracted by mini-css-extract-plugin
export default {"main":"StudentQuestions_main__Z0-9Y","block":"StudentQuestions_block__SIWXx","blocks":"StudentQuestions_blocks__qUc-D"};